<template>
  <div class="share-dialog_mobile" @contextmenu.stop>
    <el-dialog width="100%" top="calc(100vh - 177px)" custom-class="book-share_mobile" center :visible.sync="dialogVisible" :close-on-click-modal="true" :append-to-body="true">
      <div class="share-content" :style="{ 'background-color': colorContent['mobile-nav'], color: colorContent['mobile-txt'] }">
        <div class="content">
          <div class="content-item" @click="shareWechat">
            <div class="icon" :class="{ dark: colorContent['mobile-icon'] === 0 }"><img style="width: 35px" :src="icons.wechatIcon" /></div>
            <div class="text">{{ language.wechat }}</div>
          </div>
          <div class="content-item" v-if="selposter" @click="showPoster()">
            <div class="icon" :class="{ dark: colorContent['mobile-icon'] === 0 }"><img :src="icons.posterIcon" /></div>
            <div class="text">{{ language.poster }}</div>
          </div>
          <div class="content-item" @click="handleCopy">
            <div class="icon tag-read" :class="{ dark: colorContent['mobile-icon'] === 0 }" :data-clipboard-text="qrValPage"><img :src="icons.linkIcon" /></div>
            <div class="text">{{ language.link }}</div>
          </div>
        </div>
        <div class="option">
          <el-checkbox style="margin-bottom: 10px" v-model="isSharePage" @change="changeSharePage"></el-checkbox>
          <span>{{ currentLang === 1 ? 'Share this page' : '分享当前页' }}</span>
        </div>
      </div>
      <div class="wechat-tips" @click="showModal = false" v-show="showModal">
        <img style="width: 52px;float: right;margin-top: 22px;;margin-right: 15px" src="@imgs/mobile_footer/arrow.png" />
        <p class="en" v-if="currentLang === 1">Click the … to share with<br />WeChat Friends or Moments</p>
        <p v-else>点击右上角 … 分享给<br />微信好友或分享到朋友圈</p>
        <button>{{ currentLang === 1 ? 'Confirm' : '我已了解' }}</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import imgSrc from '../imgSrc'
import apis from '@api/getBook'
import wxSetting from '@components/common/wxSetting'
import { isPureNum } from '@utils'
export default {
  name: 'MobileShareDialog',
  data() {
    return {
      dialogVisible: false,
      isSharePage: false,
      qrValPage: this.qrVal,
      showModal: false
    }
  },
  mixins: [wxSetting],
  props: {
    qrObj: {
      type: Object,
      default: function() {
        return {}
      }
    },
    qrVal: {
      type: String,
      default: ''
    },
    currentLang: {
      default: 0
    }
  },
  computed: {
    language() {
      return this.$store.state.config.languageOptions[this.currentLang]
    },
    selposter() {
      return this.$store.state.config.poster.poster
    },
    currentPageArray() {
      return this.$store.state.book.currentPage
    },
    colorSwitch() {
      return this.$store.state.config.bookObj.colorSwitch
    },
    colorContent() {
      return this.$store.state.config.bookObj.colorContent
    },
    icons() {
      const newVar = this.colorContent['mobile-icon']
      const iconImage = imgSrc.iconImages[newVar]
      return iconImage
    },
    isPaper() {
      return this.$store.state.book.isPaper
    },
    bookTitle() {
      return this.$store.state.config.bookObj.shareTitle
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.isSharePage = false
        this.sharePage = null
        this.qrValPage = this.qrVal
      } else {
        document.title = this.bookTitle
      }
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
      this.showModal = false
    },
    handleCopy() {
      let clipboard = new Clipboard('.tag-read')
      clipboard.on('success', (e) => {
        this.$message({
          message: this.currentLang === 1 ? 'Success' : '复制网址成功',
          type: 'success'
        })
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        console.log('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    },
    showPoster() {
      this.$emit('showPoster', this.qrValPage)
      this.handleCancel()
    },
    shareWechat() {
      if (this.isSharePage) {
        const page = Math.max(this.currentPageArray[this.sharePage || 0] || 1)
        this.$router.replace({ path: this.$route.fullPath, query: { page: page } })
        const wxParams = {
          id: isPureNum(this.$route.query.id),
          currentUrl: window.location.href
        }
        if (this.isPaper) {
          this.getWXConfig(wxParams, apis.getPaperWXConfig, true, this.bookTitle + `第${page}版`)
          document.title = this.bookTitle + `第${page}版`
        } else {
          this.getWXConfig(wxParams, apis.getWXConfig, false, this.bookTitle + `第${page}页`)
          document.title = this.bookTitle + `第${page}页`
        }
      } else {
        document.title = this.bookTitle
      }
      this.showModal = true
    },
    changeSharePage() {
      let newHref = this.qrVal
      if (newHref.indexOf('&page=') > 0) {
        newHref = newHref.replace(/&page=\d+/, '')
      }
      if (this.isSharePage) {
        const page = Math.max(this.currentPageArray[this.sharePage || 0] || 1)
        this.qrValPage = newHref + '&page=' + page
        document.title = this.bookTitle + `第${page}${this.isPaper ? '版' : '页'}`
      } else {
        this.sharePage = null
        this.qrValPage = newHref
        document.title = this.bookTitle
      }
      this.$emit('changeSharePage', this.qrValPage)
    }
  }
}
</script>
<style lang="scss">
.book-share_mobile {
  height: 177px;
  margin-bottom: 0 !important;
  .el-dialog__header {
    height: 0;
  }
  .el-dialog__body {
    padding: 0 !important;
    height: 100%;
    .share-content {
      height: 100%;
      padding-top: 20px;
      .content {
        display: flex;
        justify-content: space-around;
        border-bottom: 1px solid #e5e5e5;
        margin: 0 10px;
        padding-bottom: 15px;
        .content-item {
          text-align: center;
          .icon {
            width: 60px;
            height: 60px;
            line-height: 60px;
            left: 279px;
            top: 21px;
            border-radius: 10px;
            background: rgba(56, 56, 56, 0.1);
            margin-bottom: 10px;
            img {
              width: 30px;
              vertical-align: middle;
            }
            &.dark {
              background: rgba(255, 255, 255, 0.2);
            }
          }
        }
      }
      .option {
        padding: 7px 35px;
        .el-checkbox {
          margin-right: 10px;
          .el-checkbox__inner {
            border-color: unset !important;
          }
        }
      }
    }
    .wechat-tips {
      position: fixed;
      height: 100vh;
      width: 100vw;
      background: rgba(0, 0, 0, 0.85);
      top: 0;
      text-align: center;
      z-index: 99;
      p {
        width: 220px;
        font-size: 20px;
        font-weight: 400;
        line-height: 29.06px;
        color: rgba(255, 255, 255, 1);
        vertical-align: top;
        margin: 50px auto 20px auto;
        &.en {
          width: 300px;
          word-break: break-word;
        }
      }
      button {
        font-size: 18px;
        color: #000000;
      }
    }
  }
}
</style>
